import { Link } from "react-router-dom";
import { Column } from "react-table";
import { formatDate } from "../../api/DateUtils";
import {
  GetComplianceInvestigationsBySiteVisitFetchUrl,
  IComplianceInvestigation,
} from "../../api/IComplianceInvestigation";
import { GetComplianceRecordDetailsUrl } from "../../leap-pages/routeFactory";
import { Grid } from "../Grid";
import { getIconForType } from "../icons/LeapIcons";
import { ComplianceInvestigationsGridProps } from "./ComplianceInvestigationsGridProps";

const complianceInvestigation = "Compliance Investigation";

const ComplianceInvestigationsGrid = ({
  relatedRecordType,
  relatedrecordId,
  licenceProfile,
}: ComplianceInvestigationsGridProps) => {
  const getFetchUrlFactory = (relatedId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      switch (relatedRecordType) {
        case "Site Visit":
        default:
          return GetComplianceInvestigationsBySiteVisitFetchUrl(
            relatedId,
            pageNo,
            recordsPerPage,
            searchText,
            filters
          );
      }
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(relatedrecordId);

  const tableColumnsBig: Column<Record<string, IComplianceInvestigation>>[] = [
    {
      Header: "Ref. No.",
      accessor: "reference",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td style={{ paddingTop: "6px" }}>
              <span>{getIconForType(complianceInvestigation)}</span>
            </td>
            <td>
              <Link
                to={GetComplianceRecordDetailsUrl(
                  rowInfo.row.original.complianceinvestigationid,
                  complianceInvestigation,
                  licenceProfile.profileNo
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Date",
      accessor: "dateraised",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Investigation Title",
      accessor: "title",
      Filter: false,
    },
    {
      Header: "Issue / Theme",
      accessor: "issue",
      Filter: false,
      filter: "includes",
    },
    {
      Header: "Status",
      accessor: "status",
      Filter: false,
      filter: "includes",
    },
  ];

  const tableColumnsSmall: Column<Record<string, IComplianceInvestigation>>[] =
    [
      {
        Header: "Ref. No.",
        accessor: "reference",
        Filter: false,
        filter: "includes",
        Cell: (rowInfo: any) => (
          <table>
            <tr>
              <td style={{ paddingTop: "6px" }}>
                <span>{getIconForType(complianceInvestigation)}</span>
              </td>
              <td>
                <Link
                  to={GetComplianceRecordDetailsUrl(
                    rowInfo.row.original.complianceinvestigationid,
                    complianceInvestigation,
                    licenceProfile.profileNo
                  )}
                >
                  {rowInfo.value}
                </Link>
              </td>
            </tr>
          </table>
        ),
      },
      {
        Header: "Investigation Title",
        accessor: "title",
        Filter: false,
      },
    ];

  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
    </div>
  );

  return bodyElements;
};

export { ComplianceInvestigationsGrid };
